<template>
  <div class="record-container">
    <div class="record-content">
      <span class="record-primary">{{ primary }} </span> <br/>
      <span class="record-secondary"> {{ secondary }} </span>
    </div>
    <div class="small-status"><GcSmallStatus :status="status" /></div>
  </div>
</template>

<script>
import GcSmallStatus from "./gc-small-status.vue";

export default {
  props: {
    primary: {
      type: String,
    },
    secondary: {
      type: String,
    },
    status: {
      type: String,
    },
  },
  data() {
    return {
      testPrimary:
        "This is a very long long long long long long long long long long long long long long long long long long name",
    };
  },
  components: {
    GcSmallStatus,
  },
  computed: {},
  created() {},
};
</script>

<style lang="scss" scoped>
// .record-content {
//   font-size: 16px;
//   text-align: left;
//   display: inline-block;
//   width: 300px;
// }
.record-secondary {
  font-size: 10px;
  text-align: left;
  color: grey;
  display: inline-block;
}

.record-primary {
  padding-right: 5px;
  white-space: normal;
}

.small-status {
  display: inline-block;
  padding-right: 5px;
  float: right;
}

.record-container{
  display: inline-flex;
  align-items: flex-start;
  justify-content: space-between;
  // padding-left: unset !important;
}

.record-container::before{
  content: unset;
}
</style>
